import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessBasicMetadataComponentAbstract } from '../../metadata-components/business-basic-metadata/business-basic-metadata.component.abstract';

@Component({
  selector: 'app-business-basic-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, CustomDatePipe],
  templateUrl: './business-basic-metadata-v2.component.html',
})
export class BusinessBasicMetadataV2Component extends BusinessBasicMetadataComponentAbstract {}
